import TERow from './TERow';

export default TERow;
